import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import axios from "axios";
import "bootstrap/dist/js/bootstrap.min.js";
import PartidoCards from "./PartidoCard";
import descargaArchivo from "./DescargaArchivo";
import ResultadoFlujo from "./ResultadoFlujo";
import LeerArchivoTxt from "./LeerArchivoTxt";
import ModalConfirmar from "./ModalConfirmar";
import ModalCancelar from "./ModalCancelar";
import ModalEditar from "./ModalEditar";
import { useParams } from "react-router-dom";
import GoBack from "../General/GoBack";
import { Button, Modal } from "react-bootstrap";
import API_URL from "../../localhost/config"; //Importa la variable global
import Sidebar from "../Sidebar/Sidebar";

import Spinner from "../utils/Spinner";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import BotonExcel from "../utils/BotonExcel";

const notifyWanr = (mensaje) => {
  toast.warn(mensaje, {
    position: "bottom-right",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

function Dropdown({
  equipos,
  onEquipoSeleccionado,
  equipoSeleccionado,
  disabled,
}) {
  return (
    <div className="dropdown">
      <button
        className="btn btn-outline-secondary dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        disabled={disabled}
      >
        {equipoSeleccionado ? equipoSeleccionado.Nombre : "Seleccionar equipo"}
      </button>
      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
        {equipos?.map((equipo) => (
          <li key={equipo.id}>
            <button
              className="dropdown-item"
              onClick={() => onEquipoSeleccionado(equipo)}
            >
              {equipo.Nombre}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

// -----------------------------

function InputGroup({
  equipos,
  onEquipoSeleccionado,
  equipoSeleccionado,
  disabled,
}) {
  const [mostrarDropdown, setMostrarDropdown] = useState(false);
  const [filtro, setFiltro] = useState("");

  const filtrarEquipos = () => {
    return equipos?.filter((equipo) =>
      equipo.Nombre.toLowerCase().includes(filtro.toLowerCase())
    );
  };

  const handleEquipoSeleccionado = (equipo) => {
    onEquipoSeleccionado(equipo);
  };

  return (
    <div className="input-group">
      <div className="input-group-prepend">
        <Dropdown
          equipos={filtrarEquipos()}
          onEquipoSeleccionado={handleEquipoSeleccionado}
          equipoSeleccionado={equipoSeleccionado} // Pasar el equipo seleccionado al Dropdown
          disabled={disabled}
        />
      </div>
    </div>
  );
}

// -----------------------------

function ArmarPartido({ equipos }) {
  const [equipoSeleccionado1, setEquipoSeleccionado1] = useState(null);
  const [equipoSeleccionado2, setEquipoSeleccionado2] = useState(null);
  const [partidosArmados, setPartidosArmados] = useState([]);
  const [resultadoFlujo, setResultadoFlujo] = useState("");
  const [indicePartido, setCambiarIndice] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [contenidoArchivo, setContenidoArchivo] = useState("");
  const { idTorneo } = useParams();
  const [error, setError] = useState(null);

  // Guardo todos los equipos seleccionados para que no puedan volver a elegirse.
  const [equiposSeleccionados, setEquiposSeleccionados] = useState([]);

  //Backup equipos seleccionados por si quiere volver atras
  const [backUpequiposSeleccionados, setBackUp] = useState([]);

  // Se setea en false cuando se crea el flujo. Impide que se puedan
  // seleccionar más equipos hasta confirmar o cancelar la fecha.
  const [crearFlujo, setCrearFlujo] = useState(false);

  // Modal para confirmar la creacion de flujo sin seleccionar a todos los equipos del dropdown.
  const [showModalConfirmation, setShowModalConfirmation] = useState(false);

  // Modales para confirmar o cancelar fecha creada.
  const [mostrarModalConfirmar, setMostrarModalConfirmar] = useState(false);
  const [mostrarModalCancelar, setMostrarModalCancelar] = useState(false);
  const [mostrarModalEditar, setMostrarModalEditar] = useState(false);

  const [seCancelo, setSeCancelo] = useState(false);

  //Loading
  const [isLoading, setIsLoading] = useState(false); // Estado para controlar si los datos están cargados

  //Token
  const [token, setToken] = useState(localStorage.getItem("token"));

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const recuperarPartidos = () => {
    setPartidosArmados(backUpequiposSeleccionados);
  };

  const limpiarResultadoFlujo = () => {
    setResultadoFlujo("");
  };

  const habilitarCrearPartidos = () => {
    setCrearFlujo(false);
  };

  const limpiarEquiposSeleccionados = () => {
    setEquiposSeleccionados([]);
  };

  const limpiarBackup = () => {
    setBackUp([]);
  };

  const crearPartidos = () => {
    setIsLoading(true);
    setResultadoFlujo("");
    setBackUp(partidosArmados);
    try {
      let partidosTransformados = [];
      // isChecked
      //   ? (partidosTransformados = partidosArmados)
      //   : (partidosTransformados = partidosArmados.map((partido) => ({
      //       equipoSeleccionado1: partido.equipoSeleccionado1?.Nombre,
      //       equipoSeleccionado2: partido.equipoSeleccionado2?.Nombre,
      //     })));

      partidosTransformados = partidosArmados.map((partido) => ({
        equipoSeleccionado1: partido.equipoSeleccionado1?.Nombre,
        equipoSeleccionado2: partido.equipoSeleccionado2?.Nombre,
      }));

      const jsonBody = {
        data: partidosTransformados,
        idTorneo: idTorneo,
      };

      axios
        .post(`${API_URL}/getFlujo`, jsonBody, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((result) => {
          // setResultadoFlujo(result.data);
          // setPartidosArmados([]);
          console.log(result.data.result.errors);
          if (result.data.result.errors.length > 0) {
            console.error("Se encontraron errores:", result.data.result.errors);
            const errores = result.data.result.errors;
            errores.map((error) => {
              notifyWanr(
                `Hubo un error al buscar el nombre ${error.nombreIngresado} en nuestra base. Verifique que exista o este bien escrito.`
              );
            });
          } else {
            console.log(result.data.result.data);
            setResultadoFlujo(result.data.result.data);
            setPartidosArmados([]);
          }
        })
        .finally(() => {
          setIsLoading(false); // Establecer isLoading en false cuando la solicitud axios haya finalizado
        });
    } catch (error) {
      setError("Error al llamar a la función del backend");
      setIsLoading(false);
    }
  };

  const handleEquipoSeleccionado1 = (equipo) => {
    if (!equipoSeleccionado1) {
      // Si equipoSeleccionado1 es null, asigna el nuevo equipo
      setEquipoSeleccionado1(equipo);
      setEquiposSeleccionados((prevEquipos) => [...prevEquipos, equipo]);
    } else {
      // Si equipoSeleccionado1 ya tiene un valor, quita ese valor de EquiposSeleccionados
      setEquiposSeleccionados((prevEquipos) =>
        prevEquipos?.filter((e) => e !== equipoSeleccionado1)
      );

      // Asigna el nuevo equipo a equipoSeleccionado1
      setEquipoSeleccionado1(equipo);

      // Agrega el nuevo equipo a EquiposSeleccionados
      setEquiposSeleccionados((prevEquipos) => [...prevEquipos, equipo]);
    }
  };

  const handleEquipoSeleccionado2 = (equipo) => {
    if (!equipoSeleccionado2) {
      // Si equipoSeleccionado1 es null, asigna el nuevo equipo
      setEquipoSeleccionado2(equipo);
      setEquiposSeleccionados((prevEquipos) => [...prevEquipos, equipo]);
    } else {
      // Si equipoSeleccionado1 ya tiene un valor, quita ese valor de EquiposSeleccionados
      setEquiposSeleccionados((prevEquipos) =>
        prevEquipos?.filter((e) => e !== equipoSeleccionado2)
      );

      // Asigna el nuevo equipo a equipoSeleccionado1
      setEquipoSeleccionado2(equipo);

      // Agrega el nuevo equipo a EquiposSeleccionados
      setEquiposSeleccionados((prevEquipos) => [...prevEquipos, equipo]);
    }
  };

  const handleClickArmarPartido = () => {
    if (!equipoSeleccionado1 || !equipoSeleccionado2) {
      setError("Por favor, selecciona ambos equipos antes de armar un partido");
      return;
    } else {
      setError(null);
    }

    const nuevoPartido = {
      equipoSeleccionado1,
      equipoSeleccionado2,
      indice: indicePartido,
    };

    setCambiarIndice(indicePartido + 1);

    setPartidosArmados((prevPartidos) => [...prevPartidos, nuevoPartido]);

    setEquipoSeleccionado1(null);
    setEquipoSeleccionado2(null);
  };

  const handleEliminarPartido = (id) => {
    // Filtrar los partidos para excluir el partido eliminado
    const nuevosPartidos = partidosArmados?.filter((partido) => {
      return partido.indice !== id;
    });

    // Obtener los equipos del partido eliminado
    const equipo1Eliminado = partidosArmados.find(
      (partido) => partido.indice === id
    )?.equipoSeleccionado1;
    const equipo2Eliminado = partidosArmados.find(
      (partido) => partido.indice === id
    )?.equipoSeleccionado2;

    // Filtrar los equipos seleccionados para excluir los equipos del partido eliminado
    const nuevosEquiposSeleccionados = equiposSeleccionados.filter(
      (equipo) => equipo !== equipo1Eliminado && equipo !== equipo2Eliminado
    );

    // Establecer los nuevos estados
    setPartidosArmados(nuevosPartidos);
    setEquiposSeleccionados(nuevosEquiposSeleccionados);
  };

  const abrirModalConfirmar = () => {
    setMostrarModalConfirmar(true);
  };

  const cerrarModalConfirmar = () => {
    setMostrarModalConfirmar(false);
    setCrearFlujo(false);
  };

  const abrirModalEditar = () => {
    setMostrarModalEditar(true);
  };

  const cerrarModalEditar = () => {
    setMostrarModalEditar(false);
    //setCrearFlujo(false);
  };

  const abrirModalCancelar = (accion) => {
    setMostrarModalCancelar(true);
  };

  const cerrarModalCancelar = () => {
    setMostrarModalCancelar(false);
  };

  useEffect(() => {
    if (seCancelo) {
      setCrearFlujo(false);
      setResultadoFlujo("");
    }
  }, [seCancelo]);

  const handleConfirmarCrearFlujo = () => {
    if (equipos.length !== equiposSeleccionados.length) {
      setShowModalConfirmation(true);
    } else {
      handleCrearFlujo();
    }
  };

  const handleCrearFlujo = () => {
    if (partidosArmados.length > 0) {
      setBackUp(partidosArmados);
      setCrearFlujo(true);
      crearPartidos();
      //setEquiposSeleccionados([]);
    } else {
      setError("No hay partidos armados");
    }
    setShowModalConfirmation(false);
  };
  return (
    <div className="row p-0 g-0">
      {error && <div className="alert alert-danger">{error}</div>}

      <div className="col-sm-6 mx-auto p-0 g-0">
        <div className="d-flex justify-content-center">
          <div class="form-check">
            <input
              className="form-check-input m-2 p-2"
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
              id="flexCheckDefault"
            />
            <label className="form-check-label" htmlFor="flexCheckDefault">
              Carga masiva
            </label>
          </div>
        </div>

        {isChecked === true ? (
          <div className="d-flex justify-content-center">
            <div>
              <div>Carga masiva</div>
              <LeerArchivoTxt
                onContenidoChange={setContenidoArchivo}
                onPartidosArmadosChance={setPartidosArmados}
              />
            </div>
          </div>
        ) : (
          <div className="row align-items-center mb-4 px-5 g-0">
            <div className="col-md-4 col-sm-12 px-2 mb-2 mb-md-0">
              <InputGroup
                equipos={equipos?.filter(
                  (equipo) => !equiposSeleccionados?.includes(equipo)
                )}
                equipoSeleccionado={equipoSeleccionado1}
                onEquipoSeleccionado={handleEquipoSeleccionado1}
                disabled={crearFlujo}
              />
            </div>
            <div className="col-md-4 col-sm-12 px-2 mb-2 mb-md-0">
              <InputGroup
                equipos={equipos?.filter(
                  (equipo) => !equiposSeleccionados?.includes(equipo)
                )}
                onEquipoSeleccionado={handleEquipoSeleccionado2}
                equipoSeleccionado={equipoSeleccionado2}
                disabled={crearFlujo}
              />
            </div>
            <div className="col-md-4 col-sm-12 px-2">
              <button
                className="btn btn-primary w-100"
                onClick={() => handleClickArmarPartido()}
                disabled={crearFlujo}
              >
                Armar Partido{" "}
                <Icon
                  icon="bi:arrow-right-square-fill"
                  width="24"
                  height="24"
                />
              </button>
            </div>
          </div>
        )}

        <div className="col-sm-12 px-5">
          {partidosArmados
            ?.reduce((rows, partido, index) => {
              if (index % 2 === 0) rows.push([]);
              rows[rows.length - 1].push(
                <div className="col-md-6 mb-4 g-0 px-2" key={partido.indice}>
                  {partido.equipoSeleccionado1 &&
                  partido.equipoSeleccionado2 ? (
                    <PartidoCards
                      equipoA={partido.equipoSeleccionado1.Nombre}
                      equipoB={partido.equipoSeleccionado2.Nombre}
                      onEliminar={() => handleEliminarPartido(partido.indice)}
                    />
                  ) : null}
                </div>
              );
              return rows;
            }, [])
            .map((row, rowIndex) => (
              <div className="row g-0" key={rowIndex}>
                {row}
              </div>
            ))}
        </div>
        <div
          className="d-flex justify-content-center"
          style={{ paddingBottom: "20px" }}
        >
          {isLoading ? (
            <Spinner />
          ) : (
            <button
              className="btn btn-success btn-block"
              onClick={handleConfirmarCrearFlujo}
              disabled={crearFlujo}
            >
              Crear fecha
            </button>
          )}
        </div>

        {/* Muestra el resultado del flujo, cuando se termina de obtener. */}
        <div>
          {
            <ResultadoFlujo
              jsonResultadoFlujo={resultadoFlujo}
              idTorneo={idTorneo}
            />
          }
        </div>

        {resultadoFlujo ? (
          <div>
            <div className="text-center mt-3" style={{ paddingBottom: "20px" }}>
              <button
                className="btn btn-success btn-md m-1"
                onClick={() => abrirModalConfirmar()}
              >
                Confirmar turno
              </button>
              <button
                className="btn btn-warning btn-md m-1"
                onClick={() => abrirModalEditar()}
              >
                Volver a editar
              </button>
              <button
                className="btn btn-danger m-1"
                onClick={() => abrirModalCancelar()}
              >
                Cancelar turno
              </button>
              <BotonExcel infoFlujo={resultadoFlujo} />
            </div>
            <ModalConfirmar
              mostrarModal={mostrarModalConfirmar}
              cerrarModal={cerrarModalConfirmar}
              idTorneo={idTorneo}
              jsonResultadoFlujo={resultadoFlujo}
              limpiarEquiposSeleccionados={limpiarEquiposSeleccionados}
              limpiarBackup={limpiarBackup}
            />
            <ModalCancelar
              mostrarModal={mostrarModalCancelar}
              cerrarModal={cerrarModalCancelar}
              idTorneo={idTorneo}
              setSeCancelo={setSeCancelo}
              limpiarEquiposSeleccionados={limpiarEquiposSeleccionados}
              limpiarBackup={limpiarBackup}
            />
            <ModalEditar
              mostrarModal={mostrarModalEditar}
              cerrarModal={cerrarModalEditar}
              volverAtras={recuperarPartidos}
              limpiarResultado={limpiarResultadoFlujo}
              habilitarFlujo={habilitarCrearPartidos}
            />
          </div>
        ) : null}
      </div>

      <Modal
        show={showModalConfirmation}
        onHide={() => setShowModalConfirmation(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Advertencia</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Estás por crear una fecha que no contiene a todos los equipos.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowModalConfirmation(false)}
          >
            Cancelar
          </Button>
          <Button variant="success" onClick={handleCrearFlujo}>
            Crear fecha de todas maneras
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

// -----------------------------

function PageArmarEquipo() {
  const [data, setData] = useState(null);
  const { idTorneo } = useParams();
  //Token
  const [token, setToken] = useState(localStorage.getItem("token"));

  useEffect(() => {
    fetch(`${API_URL}/getTeams?idTorneo=${idTorneo}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => setData(data));
  }, [idTorneo]);

  return (
    <div className="row p-0 g-0">
      <div className="col-sm-auto p-0 g-0 flex-column">
        <Sidebar> </Sidebar>
      </div>
      <div className="col-sm p-0 g-0">
        <div className="section-title mt-5">
          <h3>
            Crea <span>la fecha</span>
          </h3>
          <p>
            Elegí los equipos que se enfrentan para buscar la mejor opción de
            día, horario y lugar para ellos.
          </p>
        </div>
        <ArmarPartido equipos={data} />
      </div>
    </div>
  );
}

export default PageArmarEquipo;
